import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface ToggleSidebarButtonProps {
  onClick: () => void;
  isVisible?: boolean;
  label?: string;
  position?: "right" | "left";
  className?: string;
  style?: React.CSSProperties;
  direction?: "left" | "right";
}

export default function ToggleSidebarButton({
  onClick,
  isVisible = true,
  label = "Open sidebar",
  position = "right",
  className = "",
  style,
  direction = "left",
}: ToggleSidebarButtonProps) {
  if (!isVisible) return null;

  const positionClasses = position === "right"
    ? "right-0 rounded-l-md"
    : "left-0 rounded-r-md";

  return (
    <button
      onClick={onClick}
      className={`toggle-sidebar-button fixed top-1/2 z-20 flex h-[120px] w-6 -translate-y-1/2 items-center justify-center bg-primary text-primary-foreground shadow-md transition-transform ${style ? (position === "right" ? "rounded-l-md" : "rounded-r-md") : positionClasses} ${className}`}
      style={style}
      aria-label={label}
    >
      {direction === "left" ? <ChevronLeft size={16} /> : <ChevronRight size={16} />}
    </button>
  );
}